module.exports = __webpack_public_path__ + "static/media/tbl_bg.edff22dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tbl_bg.png
// module id = 2248
// module chunks = 0